module.exports = __webpack_public_path__ + "img/undraw_empty_re_opql.48c8143b.svg";